export default Vue => {
  Vue.component("v-cookies", () => import("./v-cookies.vue"));
};
